<template>
  <div
    class="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4"
  >
    <Skeleton v-if="!gallery" class="aspect-[5/7]" />

    <div
      v-for="art in gallery"
      class="group block w-full overflow-hidden rounded-md relative aspect-[5/7] cursor-pointer shadow-md select-none"
      role="button"
      @click="lightbox(art.url)"
    >
      <AsyncImage
        :src="art.url"
        alt="cover"
        class="min-h-full min-w-full pointer-events-none object-cover group-hover:opacity-80 group-active:opacity-60 select-none"
      />
    </div>
  </div>
  <VueEasyLightbox
    :visible="visibleRef"
    :imgs="imgsRef"
    :index="indexRef"
    @hide="visibleRef = false"
  />
</template>

<script setup lang="ts">
import VueEasyLightbox from "vue-easy-lightbox";

interface Props {
  gallery?: { url: string }[];
  edit?: boolean;
}

type ImgRef =
  | string
  | string[]
  | { title: string; src: string }
  | { title: string; src: string }[];

const props = defineProps<Props>();
const config = useRuntimeConfig();

const visibleRef = ref(false);
const indexRef = ref(0);
const imgsRef = ref<ImgRef>([]);

function lightbox(url: string) {
  imgsRef.value = url;
  visibleRef.value = true;
}
</script>
